import React, { useState, useEffect } from "react";
import { makeStyles, IconButton } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";

import ModalImage from "react-modal-image";
import api from "../../services/api";

const useStyles = makeStyles(theme => ({
	messageMedia: {
		objectFit: "cover",
		width: 250,
		height: 200,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
}));

const ModalImageCors = ({ imageUrl }) => {
	const classes = useStyles();
	const [fetching, setFetching] = useState(true);
	const [blobUrl, setBlobUrl] = useState("");

	useEffect(() => {
		if (!imageUrl) return;
		const fetchImage = async () => {
			const isAbsolute = imageUrl.startsWith("http");
			const urlToFetch = isAbsolute ? imageUrl : imageUrl; // Axios handles absolute URLs, but we clarify it
			const { data, headers } = await api.get(urlToFetch, {
				responseType: "blob",
			});
			const url = window.URL.createObjectURL(
				new Blob([data], { type: headers["content-type"] })
			);
			setBlobUrl(url);
			setFetching(false);
		};
		fetchImage();
	}, [imageUrl]);

	const handleDownload = () => {
		const url = fetching ? imageUrl : blobUrl;
		const a = document.createElement("a");
		a.href = url;
		a.download = "image.png";
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	return (
		<div style={{ position: "relative" }}>
			<ModalImage
				className={classes.messageMedia}
				smallSrcSet={fetching ? imageUrl : blobUrl}
				medium={fetching ? imageUrl : blobUrl}
				large={fetching ? imageUrl : blobUrl}
				alt="image"
			/>
			<IconButton
				style={{
					position: "absolute",
					bottom: 12,
					right: 12,
					backgroundColor: "rgba(255, 255, 255, 0.75)",
					padding: 6
				}}
				size="small"
				onClick={handleDownload}
				title="Baixar Imagem"
			>
				<GetApp fontSize="small" style={{ color: "#333" }} />
			</IconButton>
		</div>
	);
};

export default ModalImageCors;
